/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Empty_Field_ForbiddenInputs */



/**
* | output |
* | --- |
* | "This field cannot be empty" |
*
* @param {Empty_Field_ForbiddenInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const empty_field_forbidden = /** @type {((inputs?: Empty_Field_ForbiddenInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Empty_Field_ForbiddenInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("This field cannot be empty")
	return /** @type {LocalizedString} */ ("Ce champ ne pas être vide")
});